import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  ColDef,
  ColumnApi,
  GridApi,
  ValueGetterParams,
} from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FeaturelistService } from 'src/app/_services/featurelist/featurelist.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { UserService } from 'src/app/_services/user/user.service';
import { ActionItemsGridRowRendererComponent } from '../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-function-list',
  templateUrl: './function-list.component.html',
  styleUrls: ['./function-list.component.scss']
})
export class FunctionListComponent implements OnInit {
  featurelistForm
  public columnDefs: ColDef[];
  modeAction: number = 1; //1 - create // 2 - update
  // gridApi and columnApi
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any;
  tenantId: string;
  userDetails: any;
  form: FormGroup;
  selectedRow: any;
  modalService: any;
  currentUser: any;
  jsonData: any;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  projectDetailList = [];
  deleteConfirmationMsg = 'Are you sure you want to delete';
  rowData: any;

  constructor(
    private storageService: LocalStorageService,
    private featurelistService: FeaturelistService,
    private formBuilder: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private allocationService: AllocationService,
    private userService: UserService
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent,
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required],
    });

    this.featurelistForm = new FormGroup({
    featureName: new FormControl('',[Validators.required]),
    featureFamilyCategory: new FormControl('',[Validators.required]),
    featureFamilyCode: new FormControl('',[Validators.required]),
    featureFamilyName: new FormControl(''),
    featureCode: new FormControl('',[Validators.required,Validators.pattern('^[0-9]*$')]),
    effectiveState: new FormControl(''),
    effectiveDate: new FormControl(''),
    featureChangeOrderNumber: new FormControl(''),
    featureChangeOrderStatus: new FormControl(''),
    comment: new FormControl(''),
    extraField1: new FormControl(''),
    extraField2: new FormControl(''),
    extraField3: new FormControl(''),
    extraField4: new FormControl(''),
    extraField5: new FormControl(''),
    });

  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.getFeatureListData();
  }

  get f(){
    return this.featurelistForm.controls;
  }

  getFeatureListData() {
    this.featurelistService.getAllFeatureLists().subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

   // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
   onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

   // create column definitions  
   private createColumnDefs() {
    return [
    //   {
    //   headerName: '', 
    //   width: 150,
    //   field: 'delete', 
    //   cellRenderer: "actionRowRendererComponent",
    //   cellRendererParams: {
    //     onClick: this.performGridActionItem.bind(this),
    //     deleteRequired: true,
    //   }
    // },
    {
      headerName: 'Feature Name',
      field: 'featureName',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'Feature Family Category',
      field: 'featureFamilyCategory',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Feature Family Code',
      field: 'featureFamilyCode',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Feature Family Name',
      field: 'featureFamilyName',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Feature Code',
      field: 'featureCode',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Effective State',
      field: 'effectiveState',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Effective Date',
      field: 'effectiveDate',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Feature Change Order Number',
      field: 'featureChangeOrderNumber',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Feature Change Order Status',
      field: 'featureChangeOrderStatus',
      filter: true,
      editable: false,
      sortable: true,
      hide: true,
    },
    {
      headerName: 'Comment',
      field: 'comment',
      filter: true,
      editable: false,
      sortable: true
    },
  ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  createFeatureList() {
    let details = JSON.stringify(this.featurelistForm.value);
    this.featurelistService.createFeatureLists(details).subscribe(response => {
      console.log("response: ", response);
      
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.featurelistService.deleteFeatureLists(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.featurelistForm.patchValue(this.selectedCheckboxData[0])
  }

  createOpenModal() {
    this.modeAction = 1;
    this.featurelistForm.patchValue({
      featureName: '',
      featureFamilyCategory: '',
      featureFamilyCode: '',
      featureFamilyName: '',
      featureCode: '',
      effectiveState: '',
      effectiveDate: '',
      featureChangeOrderNumber: '',
      featureChangeOrderStatus: '',
      comment: '',
      extraField1: '',
      extraField2: '',
      extraField3: '',
      extraField4: '',
      extraField5: '',
      
    })
  }

  updateFeatureList() {
    this.featurelistService.updateFeatureLists(this.featurelistForm.value, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getFeatureListData();
      this.selectedCheckboxData = []
      $('#closeCreateModal').click()
    })
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].featureName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].featureName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].featureName}`;
    }
  }

  deleteFeatureList() {
    this.featurelistService.deleteFeatureLists(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getFeatureListData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteFeaturelist').trigger("click");
    });
  }

}
